import { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "../../../components/ui/button";
import Common from "../../../helper/common";
import AdvanceTable from "../../../components/advanceTable";
import {
  respEnum,
  SearchTypeEnum,
  PaymentStatusEnum,
  SaleOrderStatusEnum,
  DateminFormat,
} from "../../../constants/appConstant";
import {
  AppSelect,
  AppSearchSectionSelect,
  AppInput,
} from "../../../components/appComponents";
import { useNavigate } from "react-router-dom";

const POSOrdersList = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({});
  let [fromDate, setfromDate] = useState(null);
  let [tillDate, settillDate] = useState(null);
  const [customer_id, setCustomerId] = useState(null);
  const [payment_status, setPaymentStatus] = useState(null);
  const [status, setStatus] = useState(null);
  const [customersList, setCustomersList] = useState([]);

  // Filter options
  const paymentStatusOptions = [
    { id: null, name: "All Payment Status" },
    { id: PaymentStatusEnum.Paid, name: "Paid" },
    { id: PaymentStatusEnum.Partial_Paid, name: "Partial Paid" },
    { id: PaymentStatusEnum.Un_Paid, name: "Unpaid" },
  ];

  const orderStatusOptions = [
    { id: null, name: "All Order Status" },
    // { id: SaleOrderStatusEnum., name: "Active" },
    { id: SaleOrderStatusEnum.Confirmed, name: "Confirmed" },
    { id: SaleOrderStatusEnum.Cancelled, name: "Cancelled" },
  ];

  useEffect(() => {
    getData(1);
    getCustomers();
  }, []);

  useEffect(() => {
    getData(1);
  }, [customer_id, payment_status, status, fromDate, tillDate]);

  const resetFilters = () => {
    setCustomerId(null);
    setPaymentStatus(null);
    setStatus(null);
    setfromDate(null);
    settillDate(null);
  };

  const getCustomers = async () => {
    try {
      const response = await Common.ApiService.getInstance().request(
        "ClubPlayersddl",
        {},
        "Get",
        false
      );
      if (response?.status === respEnum.Success) {
        const customerOptions = response.data.map((customer) => ({
          value: customer.id,
          label: customer.name,
        }));
        setCustomersList([
          { value: null, label: "All Customers" },
          ...customerOptions,
        ]);
      }
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  debugger;
  const getData = async (
    pageNumber,
    searchTerm = "",
    recordsToDisplay = null
  ) => {
    if (fromDate == "") {
      fromDate = null;
    }
    if (tillDate == "") {
      tillDate = null;
    }
    const response = await Common.ApiService.getInstance().request(
      "GetSaleOrders",
      {
        pageNumber: pageNumber,
        q: searchTerm,
        customer_id: customer_id,
        payment_status: payment_status,
        status: status,
        recordsToDisplay,
        fromDate: fromDate,
        tillDate: tillDate,
      },
      "POST"
    );

    if (response?.status === respEnum.Success && response?.data?.[0]) {
      const processedData = {
        ...response.data[0],
        data: response.data[0].data.map((item) => ({
          ...item,
          createdon: item.createdon
            ? Common.Utility.ConvertTime(item.createdon)
            : null,
            
          payment_status_id:item.payment_status,
          payment_status:item.payment_status?Common.Utility.getKeyByValue(PaymentStatusEnum,item.payment_status):null,

          status_id:item.status,
          status:item.status?Common.Utility.getKeyByValue(SaleOrderStatusEnum,item.status):null,


        })),
      };
      setData(processedData);
    }
  };

  const _addUpdateTrigger = () => (
    <Button size="icon" variant="outline" color="secondary" className="h-7 w-7">
      <Icon icon="heroicons:pencil" className="h-4 w-4" />
    </Button>
  );

  const _onView = async (row) => {
    navigate(`/app/pos-order-details?id=${row.id}`);
  };

  const _onPrint = async (row) => {
    navigate(`/app/pos-order-details?id=${row.id}&print=true`);
  };

  const actions = [
    {
      name: "view",
      icon: "heroicons:eye",
      tooltip: "View Details",
      variant: "outline",
      size: "icon",
      className: "h-7 w-7",
      onClick: _onView,
    },
    // {
    //   name: "print",
    //   icon: "heroicons:printer",
    //   tooltip: "Print Receipt",
    //   variant: "outline",
    //   size: "icon",
    //   className: "h-7 w-7",
    //   onClick: _onPrint,
    // },
  ];

  const getPaymentStatusBadge = (status) => {
    switch (status) {
      case PaymentStatusEnum.Paid:
        return (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
            Paid
          </span>
        );
      case PaymentStatusEnum.Partial_Paid:
        return (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
            Partial Paid
          </span>
        );
      case PaymentStatusEnum.Un_Paid:
        return (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
            Unpaid
          </span>
        );
      default:
        return (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
            Unknown
          </span>
        );
    }
  };

  const getOrderStatusBadge = (status) => {
    switch (status) {
      // case SaleOrderStatusEnum.Active:
      //   return (
      //     <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
      //       Active
      //     </span>
      //   );
      case SaleOrderStatusEnum.Confirmed:
        return (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
            Confirmed
          </span>
        );
      case SaleOrderStatusEnum.Cancelled:
        return (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
            Cancelled
          </span>
        );
      default:
        return (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
            Unknown
          </span>
        );
    }
  };

  const formatDate = (date) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(date).toLocaleDateString("en-US", options);
  };

  const _thead = [
    {
      key: "ref_no",
      title: "Order #",
      type: "text",
      isVisible: true,
      render: (row) => (
        <div className="flex flex-col">
          <span className="font-medium text-blue-600">{row.ref_no}</span>
          <span className="text-xs text-gray-500">
            {formatDate(Common.Utility.ConvertTime(row.order_date)) || "N/A"}
          </span>
        </div>
      ),
    },
    {
      key: "customerName",
      title: "Customer",
      type: "text",
      isVisible: true,
      render: (row) => (
        <span className="font-medium">
          {row.customerName || "Walk-in Customer"}
        </span>
      ),
    },
    {
      key: "payment_status",
      title: "Payment Status",
      type: "text",
      isVisible: true,
      render: (row) => getPaymentStatusBadge(row.payment_status_id),
    },
    {
      key: "status",
      title: "Order Status",
      type: "text",
      isVisible: true,
      render: (row) => getOrderStatusBadge(row.status_id),
    },
    {
      key: "net_amount",
      title: "Net Amount",
      type: "number",
      isVisible: true,
      render: (row) => (
        <div className="flex flex-col">
          <span className="font-bold text-blue-600">
            PKR {row.net_amount?.toFixed(0) || "0"}
          </span>
          {row.remaining_amount > 0 && (
            <span className="text-xs text-red-500">
              Remaining: PKR {row.remaining_amount?.toFixed(0)}
            </span>
          )}
        </div>
      ),
    },
    {
      key: "received_amount",
      title: "Received Amount",
      type: "number",
      isVisible: true,
      render: (row) => (
        <span className="font-medium text-green-600">
          PKR {row.received_amount?.toFixed(0) || "0"}
        </span>
      ),
    },
    {
      key: "createdon",
      title: "Created On",
      type: "date",
      isVisible: true,
    },
    {
      key: "createdByName",
      title: "Created By",
      type: "text",
      isVisible: true,
    },
  ];

  return (
    <>
      {/* Filters */}
      <div className="grid grid-cols-1 md:grid-cols-7 gap-4 mb-4 p-4 bg-white rounded-lg shadow-sm border">
        <AppInput
          type="date"
          value={fromDate}
          onChange={(e) => {
            const selectedstartDate = e;
            if (tillDate && selectedstartDate > tillDate) {
              Common.showToast(
                "Start Date must be lesser than till Date",
                "Error",
                "info"
              );
              setfromDate(null);
            } else {
              setfromDate(selectedstartDate);
            }
          }}
          placeholder="From Date"
          className="mb-0"
          label="From Date"
        />

        <AppInput
          type="date"
          value={tillDate}
          onChange={(e) => {
            const selectedEndDate = e;
            if (selectedEndDate < fromDate) {
              Common.showToast("End Date must be greater", "Error", "info");
              settillDate("");
            } else {
              settillDate(selectedEndDate);
            }
          }}
          placeholder="Till Date"
          label="Till Date"
          className="mb-0"
        />
        <AppSearchSectionSelect
          value={
            customersList.find((customer) => customer.value === customer_id) ||
            customersList[0]
          }
          onChange={(value) => setCustomerId(value?.value)}
          label="Customer"
          data={customersList}
          className="col-span-1"
        />

        <AppSelect
          value={payment_status}
          onChange={setPaymentStatus}
          label="Payment Status"
          data={paymentStatusOptions}
          className="col-span-1"
        />

        <AppSelect
          value={status}
          onChange={setStatus}
          label="Order Status"
          data={orderStatusOptions}
          className="col-span-1"
        />

        <Button
          className="mt-6 h-8 col-span-1"
          onClick={resetFilters}
          variant="outline"
        >
          Reset Filters
        </Button>

        <Button
          className="mt-6 h-8 col-span-1"
          onClick={() => navigate("/app/pos")}
        >
          New Order
        </Button>
      </div>

      {data?.data && (
        <AdvanceTable
          title={"POS Orders"}
          columns={_thead.filter((item) => item.isVisible)}
          data={data}
          getData={getData}
          search={SearchTypeEnum.Server_Search}
          searchInputClassName="custom-search-mobile"
          showPagination={true}
          actionButtons={actions}
          updateTrigger={_addUpdateTrigger}
          showExportoptions
          exportFileName={"Pos Order Details"}
        />
      )}
    </>
  );
};

export default POSOrdersList;
